export default __webpack_public_path__ + "static/media/shoes1-afterA-1024w.48918c9d.webp";